export default __webpack_public_path__ + "static/media/logo_dark.258f75f0.svg";